<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:header></template>
      <template v-slot:actions>
        <a-btn-refresh @click="$refs.table.updateData()" />
        <a-btn-add :icon="'far fa-plus-square'" :title="'Создать документ'" v-if="getAccess('documents.objectSell.create')" @click="createNew()" />
      </template>
      <portal to="v-main">
        <edit-dialog v-model="showEditDialog" v-if="showEditDialog && !true" :api="url" :m="m" :id="idEdit"></edit-dialog>
        <s-document-head v-model="showEditDialog" v-if="showEditDialog" :api="url" :m="m" :config="configHead" :title="m.title" :id="idEdit" />
      </portal>
      <a-table-f-api
        ref="table"
        :api="url"
        :model="getModelList(m)"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
      >
      </a-table-f-api>
      <popup-window v-if="infoSnack" :type="3" :data="infoData" :model="infoModel" />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, genModel, doubleClickDetect, keyDetect } from "@/components/mixings";

export default {
  mixins: [getAccess, genModel, doubleClickDetect, keyDetect],
  components: {
    editDialog: () => import("./dialogs/objectSellDialog"),
    ViewItem: () => import("./views/objectSellView"),
  },
  data() {
    return {
      idEdit: 0,
      showEditDialog: false,
      idItemShow: 0,
      title: "",
      m: this.$store.getters["config/get"].models.documentObjectSell,

      url: "/accounting/doc/building_sell",
      defaults: {
        sort: { key: "date_doc", order: "DESC" },
        filters: this.getAccess("documents.objectSell.viewAll") ? {} : { createdby_id: this.$root.profile.id },
        paramName: "documentObjectSell",
      },
      infoData: null,
      infoModel: null,
    };
  },
  created() {
    this.$root.title = "Договор продажи";
  },
  computed: {
    configHead() {
      return this.m.config.default || {};
    },
    permit() {
      return this.getAccess("menu.documentObjectSell");
    },
    infoSnack() {
      if (this.keysModified) {
      }
      let res = this.keys?.ctrl;
      this.infoData = null;
      this.infoModel = null;
      if (res) this.showOrderDetail();
      return res;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
    async showOrderDetail() {
      let id = this.selectedRows[0];
      if (!id) return;
      let data;
      let model;
      const d = await this.$axios.get(this.url + "/" + id);
      if (d.data && d.data.data) {
        let data = d.data.data.data_table;

        model = this.m.listDetail.filter((el) => ["name", "amount", "price_real"].includes(el.name));
        this.infoData = data;
        this.infoModel = model;
      }
    },
    onSingleClick(d) {},
    onDoubleClick(d) {
      this.idItemShow = d.row.id;
      return;
      this.onClickRow(d);
    },
    onClickRow(d) {
      this.$router.push({ name: "objectSell_view", params: { id: d.row.id } });

      //      this.showEditDialogFun(d.row.id);
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
  },
};
</script>
